import { render, staticRenderFns } from "./Projects-group-icon.vue?vue&type=template&id=5b930545"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b930545')) {
      api.createRecord('5b930545', component.options)
    } else {
      api.reload('5b930545', component.options)
    }
    module.hot.accept("./Projects-group-icon.vue?vue&type=template&id=5b930545", function () {
      api.rerender('5b930545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Projects-group-icon.vue"
export default component.exports